import InfiniteLoading from 'vue-infinite-loading';
import axios from 'axios';
import { timingSafeEqual } from 'crypto';

Vue.use(InfiniteLoading, {
  slots: {
    noMore: ''
  }
});

const api_articles = '/api/v1/articles';
const api_categories = '/api/v1/articles/categories'

Vue.component('NewsList', {
  // props: ['allarticles', 'selectedarticles'],
  data() {
    return {
      selectedCategory: {
        id: parseInt(this.take_param('c').value? this.take_param('c').value: 0),
        title: this.allproducts ? this.allproducts : 'ΟΛΑ ΤΑ ΠΡΟΙΟΝΤΑ'
      },
      allproducts: this.allproducts,
      selectedproducts: this.selectedproducts,
      page: this.take_param('p').value? this.take_param('p').value-1: 1,
      is_featured: 0,
      loading_results: 0,
      ltp: this.take_param('ltp').value?this.take_param('ltp').value:0,

      totalPages: parseInt(this.$attrs.lastpage),
      articles: [],
      prodCategories: [],
      categoriesList: false,
      lang: this.$attrs.language ? this.$attrs.language : 'el'
      
    }
  },
  computed: {
    filteredArticles() {

      var filteredArticls = [];
      if (this.selectedCategory.id === 100) {
        this.articles.filter((element) => {
          if (element.featured === true) {
            filteredArticls.push(element);
          }
        });
      } else {
        filteredArticls = this.articles;
      }
      return filteredArticls;
    }
  },
  methods: {

    toggleCategoriesListChild($event) {
      $event.stopPropagation();
    },
    toggleCategoriesList($event) {
      try {
        this.categoriesList = !this.categoriesList;
      } catch (e) {
        this.categoriesList = false;
      }
    },
    nextCategory() {
      var next_category = {
        id: 0,
        title: ''
      };
      var next_category_key = 0;
      this.prodCategories.forEach((category) => {
        if (category.id == this.selectedCategory.id && next_category_key + 1 < this.prodCategories.length) {
          next_category = this.prodCategories[next_category_key + 1];
        }
        next_category_key++;
      });
      return next_category;
    },
    selectCategory(categoryId, append = 0) {

      this.articles = [];
      if (categoryId === 0) {
        this.selectedCategory = {
          id: 0,
          title: this.allarticles
        };
      } else if (categoryId === 10000) {
        this.selectedCategory = {
          id: 10000,
          title: this.selectedarticles
        };
      } else if (categoryId > 0) {
        this.prodCategories.filter((element) => {
          if (element.id === categoryId) {
            this.selectedCategory = element;
          }
        });
      }
      this.alterGETparam('c', categoryId);
      // this.categoriesList = false;
      if (append == 1) {
        this.page = 1;
        try {
          this.$refs.infiniteLoading.stateChanger.reset();
        } catch (e) {}
      } else {
        this.page = 1;
        try {
          this.$refs.infiniteLoading.stateChanger.reset();
        } catch (e) {}
      }
    },
    infiniteHandler($state) {
      this.loading_results = 1;
      axios.get('/' + this.lang + api_articles, {
        params: {
          page: this.page,
          cat_id: this.selectedCategory.id,
          is_featured: this.is_featured,
          ltp: this.ltp
        },
      }).then(({
        data
      }) => {
        this.loading_results = 0;
        if (this.page <= data.last_page) {
          this.totalPages = data.last_page;
          this.page = data.current_page + 1;
          let newarticles = data.data;
          if(newarticles.length>0){
            this.alterGETparam('p', this.page);
          }else{
            this.alterGETparam('p', this.page-1);
          }
          // this.articles.push(...newarticles);
          this.articles = newarticles;
          $state.loaded();
          var prevHeight = 0
          try{
            prevHeight = this.take_param('h').value;
            setTimeout(function(){
              if(prevHeight>0){
                window.scrollTo(0, prevHeight);
              }
            }, 100, prevHeight);
            
          }catch(e){
            prevHeight = 0
          }
          
        } else {
          $state.complete();
        }
      });
    },
    onScroll() {
      this.categoriesList = false;
      this.ltp = 0;
      this.alterGETparam('h', window.scrollY);
      this.alterGETparam('l', this.ltp);
    },
    alterGETparam: function (param, value) {
      var clear = (typeof clear !== 'undefined') ? clear : false;
      var newURL = this.updateURLParameter(window.location.href, param, value);
      newURL = this.updateURLParameter(newURL, param, value);
      window.history.replaceState('', '', this.updateURLParameter(window.location.href, param, value));
    },
    updateURLParameter: function (url, param, paramVal) {
      var TheAnchor = null;
      var newAdditionalURL = "";
      var tempArray = url.split("?");
      var baseURL = tempArray[0];
      var additionalURL = tempArray[1];
      var temp = "";
  
      if (additionalURL) {
        var tmpAnchor = additionalURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
        if (TheAnchor)
          additionalURL = TheParams;
  
        tempArray = additionalURL.split("&");
  
        for (var i = 0; i < tempArray.length; i++) {
          if (tempArray[i].split('=')[0] != param) {
            newAdditionalURL += temp + tempArray[i];
            temp = "&";
          }
        }
      } else {
        var tmpAnchor = baseURL.split("#");
        var TheParams = tmpAnchor[0];
        TheAnchor = tmpAnchor[1];
  
        if (TheParams)
          baseURL = TheParams;
      }
  
      if (TheAnchor)
        paramVal += "#" + TheAnchor;
      var rows_txt = temp + "" + param + "=" + paramVal;
  
  
      return baseURL + "?" + newAdditionalURL + rows_txt;
    },
    take_param: function (key) {
      var params = new Map(location.search.slice(1).split('&')
        .map(function (p) {
          return p.split(/=(.*)/)
        }))
      var value = params.get(key)
      params.delete(key)
      var search = Array.from(params.entries()).map(
        function (v) {
          return v[0] + '=' + v[1]
        }).join('&')
      return {
        search: search ? '?' + search : '',
        value: value
      }
    }
  },
  mounted(){
    // this.page = this.take_param('p').value? this.take_param('p').value-1: 1;
    // var catid = this.take_param('c').value? this.take_param('c').value: 0;
    // this.selectCategory(catid);
    this.selectedCategory.title =  '';
      
    
  },
  created() {
    axios.get('/' + this.lang + api_categories).then(({
      data
    }) => {
      if (true) {
        this.prodCategories = data;
        var scid = parseInt(this.selectedCategory.id);
        var sctitle = '';
        this.prodCategories.forEach(function(value, index){
          if (value.id === scid) {
            sctitle =  value.title;
          }
        }, scid);

        this.selectedCategory.title = sctitle;
      } else {

      }
    });

    window.addEventListener('scroll', this.onScroll, {
      passive: true
    });
  },
  
})


// WEBPACK FOOTER //
// ./src/js/news-list.js